import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'
import { initAB } from '@/services/ab'
import './assets/_public-pdf.scss'

const headerJS = require('./assets/header.js')
const { header } = headerJS

export function initPagePdf(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', async function () {
    header()
    initAB()
    Mixpanel.pageView()
  })
}
